import React from "react";
import { FaHandPointRight } from "react-icons/fa";
function WhoIM() {
  return (
    <div className="bg-white flex flex-wrap items-center justify-center flex-col lg:flex-row relative">
      {/* <img
        src="./star.jpg"
        alt=""
        className="h-full w-full object-cover opacity-30 absolute bottom-0 z-0"
      /> */}
      <div className="w-full lg:w-1/2 h-1/2 lg:h-full flex items-center justify-center flex-col my-10 lg:gap-10 z-20">
        <h1 className="flex text-black text-2xl lg:text-4xl gap-2 font-bold">
          Know Who <p className="text-[#ad50eb]">I'M</p>
        </h1>
        <div className="flex items-center m-auto justify-center w-11/12 lg:w-4/5">
          <span className="flex flex-col gap-3 text-black items-start  text-base justify-center font-semibold lg:text-lg">
            <p className="text-center mt-3 mx-auto md:mx-0">
              Hi Everyone, I am <span className="text-[#ad50eb]"> Onkar</span>{" "}
              from <span className="text-[#ad50eb]">Pune, India</span>
            </p>
            <p className="lg:text-xl font-thin ">
              👋 Hello World! I'm Onkar, a frontend enthusiast hailing from the
              vibrant city of Pune, India! With experience in{"  "}
              <span className="text-[#ad50eb] font-semibold">
                frontend development
              </span>{" "}
              , I'm ready to take on the digital world! 💼 Passionate about{" "}
              <span className="text-[#ad50eb] font-semibold">
                web development
              </span>{" "}
              , I thrive on the thrill of turning ideas into captivating online
              experiences. 💻 As a dedicated{" "}
              <span className="text-[#ad50eb] font-semibold">
                React developer
              </span>{" "}
              , I specialize in crafting sleek, responsive, and user-friendly
              web applications. 🚀 Armed with a strong foundation in{" "}
              <span className="text-[#ad50eb] font-semibold">JavaScript</span>{" "}
              and <span className="text-[#ad50eb] font-semibold">React</span>,
              I'm here to make your web dreams a reality! Let's code something
              amazing together! 🌟
            </p>
            <p className="flex text-black-200 text-base lg:text-lg gap-2 font-semibold ">
              Apart from coding, some other activities that I love to do!
            </p>
            <span className="flex items-center justify-center gap-3 font-sans text-gray-900">
              <FaHandPointRight /> Reading Novels
            </span>
            <span className="flex items-center justify-center gap-3 font-sans text-gray-900">
              <FaHandPointRight /> Playing Cricket
            </span>
          </span>
        </div>
      </div>
      <div className="w-full lg:w-1/2 h-full flex items-center justify-center z-20">
        <img
          src="about.png"
          alt=""
          className="lg:p-10 object-cover lg:w-3/4 w-full"
        />
      </div>
    </div>
  );
}

export default WhoIM;
